import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {
	faShareNodes,
	faHome,
	faSuitcaseRolling,
	faInbox,
	faMagnifyingGlass,
	faCaretDown,
	faUsers,
	faShip,
	faMapMarker,
	faXmark,
	faPlane,
	faLocationDot,
	faAnglesRight,
	faEarthEurope,
	faFlagCheckered,
	faBed,
	faUtensils,
	faPlaneDeparture,
	faPlaneArrival,
	faSpinner,
	faCheck,
	faMapLocationDot,
	faCircleInfo,
	faEllipsisVertical,
	faAt,
	faPhone,
	faMobileScreen,
	faSuitcase,
	faStar,
	faInfo,
	faDollarSign,
	faPercent,
	faTrashCan as fasTrashCan,
	faBars,
	faPhoneAlt,
	faCalendarCheck as fasCalendarCheck,
	faMapMarkerAlt,
	// faEnvelope,
	faClock as fasClock,
	faPhoneAlt as fasPhoneAlt,
	faVideo,
	faMinus,
	faLock,
	faComments,
	faCookieBite,
	faRightToBracket,
	faPersonHiking,
	faUpRightFromSquare,
	faAnchorCircleCheck,
	faAnchorLock,
	faRightFromBracket,
	faCircleExclamation,
	faLifeRing,
	faUser,
	faMoon,
	faHeart,
	faHeartCrack,
	faAngleLeft,
	faCalendar,
	faStore,
} from "@fortawesome/free-solid-svg-icons";
import {
	faClock,
	faCalendarCheck,
	faFlag,
	faBookmark,
	faFaceDizzy,
	faTrashCan as farTrashCan,
	faCompass,
	faCircleXmark,
	faBell,
	faSun,
	faUserCircle,
	faThumbsUp,
	faEnvelope
} from "@fortawesome/free-regular-svg-icons";
import {
	faWhatsapp,
	faFacebookF,
	faInstagram,
	faYoutube,
	faFacebookMessenger,
	faFacebookSquare,
	faLinkedinIn,
	faWhatsappSquare,
} from "@fortawesome/free-brands-svg-icons";

if (document.body.dataset.noFa === undefined) {
	library.add(
		faHeart,
		faHeartCrack,
		faAngleLeft,
		faShareNodes,
		faHome,
		faSuitcaseRolling,
		faInbox,
		faMagnifyingGlass,
		faLifeRing,
		faCaretDown,
		faUsers,
		faShip,
		faMapMarker,
		faXmark,
		faPlane,
		faLocationDot,
		faAnglesRight,
		faEarthEurope,
		faClock,
		faFlagCheckered,
		faCalendarCheck,
		faFlag,
		faBed,
		faUtensils,
		faPlaneDeparture,
		faPlaneArrival,
		faBookmark,
		faSpinner,
		faCheck,
		faMapLocationDot,
		faCircleInfo,
		faEllipsisVertical,
		faAt,
		faPhone,
		faMobileScreen,
		faSuitcase,
		faStar,
		faInfo,
		faDollarSign,
		faPercent,
		faFaceDizzy,
		fasTrashCan,
		farTrashCan,
		faMinus,
		faCookieBite,
		faCircleExclamation,
		faBars,
		faPhoneAlt,
		fasCalendarCheck,
		faMapMarkerAlt,
		faEnvelope,
		faThumbsUp,
		fasClock,
		fasPhoneAlt,
		faVideo,
		faWhatsapp,
		faFacebookF,
		faInstagram,
		faYoutube,
		faLock,
		faComments,
		faRightToBracket,
		faPersonHiking,
		faUpRightFromSquare,
		faCompass,
		faCalendar,
		faFacebookMessenger,
		faCircleXmark,
		faAnchorCircleCheck,
		faAnchorLock,
		faRightFromBracket,
		faUser,
		faBell,
		faFacebookSquare,
		faMoon,
		faSun,
		faLinkedinIn,
		faStore,
		faUserCircle,
		faWhatsappSquare,
	);

	dom.watch();
}
